/**
 * Who sees the Schedule area's pages (the router and navigation import these without the pages).
 * The server enforces the same capabilities on every endpoint.
 */
export const SCHEDULE_VIEW = "schedule.view";
export const SCHEDULE_HISTORY = "schedule.view_history";
export const SCHEDULE_SETTINGS = "operations.manage_fulfillment";
